import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrievePlanzoneResourcesListingRequestPending() {
      return getState().request.isPending;
    },
    isRetrievePlanzoneResourcesListingRequestSuccess() {
      return getState().request.isSuccessful;
    },
    isRetrievePlanzoneResourcesListingRequestFailure() {
      return getState().request.isFailure;
    },
    getPlanzoneResourcesListing() {
      return getState().resources;
    },
    getPlanzoneResourcesListingTotalPages() {
      return getState().totalPages;
    },
    getPlanzoneResourcesListingFilter() {
      return getState().filter;
    },
  };
}

export { createSelector };
